module.exports = __webpack_public_path__ + "img/me-1.a6cf831e.jpg";